import select from 'dom-select';
import debounce from 'debounce';

export const GlobalHeader = (el) => {
  const ui = {
    el,
    body: select('body'),
    toggles: select.all('.nav-item', document),
    escape: select('.js-escape', el),
  };

  const closeAllSubnavs = () => {
    ui.toggles.forEach((toggle) => {
      toggle.removeAttribute('aria-expanded');
      ui.body.classList.remove('subnav-open');
    });
  }

  let headerHeight = ui.el.offsetHeight;
  let lastScrollTop = 20;

  const quickEscape = () => {
    // Immediately redirect to Google, replacing current location entry
    // This prevents using the back button to return to a SATC page
    // Use window.top to break out of iframes (e.g., Storybook)
    // Entry still exists in the browser history, however
    (window.top || window).location.replace("https://www.google.com");
  }

  const handleBodyScroll = () => {
    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop && ui.body) {
      if (st > headerHeight) {
        // down scroll code
        ui.body.classList.add('scrolled-down');
        ui.body.classList.remove('scrolled-up');
        closeAllSubnavs();
      }
    } else {
        // up scroll code
        ui.body.classList.add('scrolled-up');
        ui.body.classList.remove('scrolled-down');

      if (st === 0) {
        ui.body.classList.remove('scrolled-down');
        ui.body.classList.remove('scrolled-up');
      }
    }
    // For mobile or negative scrolling
    lastScrollTop = st <= 0 ? 0 : st;
  }

  const addEvents = () => {
    const debouncedScroll = debounce(handleBodyScroll, 10);
    window.addEventListener('scroll', debouncedScroll);

    if (ui.escape) {
      ui.escape.addEventListener('click', () => {
        quickEscape();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();           // Prevents default browser behavior
          e.stopPropagation();          // Stops event bubbling
          e.stopImmediatePropagation(); // Stops other listeners on the same element
          quickEscape();
        }
      }, { capture: true });
    }
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalHeader;
